import { jsx as _jsx } from "react/jsx-runtime";
import { FieldTextarea } from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';
export function GcmControls() {
    return (_jsx(Field, { component: FieldTextarea, label: "API key", name: "platformCredential", placeholder: "Google API key", required: true, type: "text" }));
}
